export const animations = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Close accordion on click
   */

  document
    .querySelectorAll(
      '.accordeon .wp-block-group > .wp-block-columns > .wp-block-column:first-child'
    )
    .forEach((element) =>
      element.addEventListener('click', function () {
        let currentContent = this.nextElementSibling;

        if (!currentContent.classList.contains('acc-el-open')) {
          var allOpenEl = document.querySelectorAll('.acc-el-open');
          allOpenEl.forEach((OpenEl) => {
            OpenEl.classList.remove('acc-el-open');
            OpenEl.parentNode.classList.remove('arrow-up');
          });

          currentContent.classList.add('acc-el-open');
          currentContent.parentNode.classList.add('arrow-up');
          currentContent.classList.remove('acc-el-close');
        } else {
          currentContent.classList.remove('acc-el-open');
          currentContent.parentNode.classList.remove('arrow-up');
          currentContent.classList.add('acc-el-close');

          setTimeout(function () {
            history.replaceState(null, null, ' ');
          }, 0);
        }
      })
    );




  /*
  /* div Elements Animations on scroll
  */
  function reveal() {
    var reveals = document.querySelectorAll('.reveal');

    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 10;

      var delay = 100;
      if (reveals[i].classList.contains('delay-1000')) {
        delay = 1000;
      }
      if (reveals[i].classList.contains('delay-500')) {
        delay = 500;
      }
      if (reveals[i].classList.contains('delay-200')) {
        delay = 200;
      }

      if (elementTop < windowHeight - elementVisible) {
        let that = reveals[i];
        setTimeout(() => {
          that.classList.add('active');
        }, delay);
      } /*  else {
        reveals[i].classList.remove("active");
      } */
    }
  }
  window.addEventListener('scroll', reveal);
  /*
  * Change width of header logo on scroll
  */
  const headerLogoCont = document.querySelector('.brand-logo');
  let lastScroll = window.scrollY;
  window.addEventListener("scroll", () => {
    if (window.scrollY - lastScroll > 0) {
      // scrolling down
      if (window.scrollY > 200) {
        headerLogoCont.classList.add('header-logo-cont-small');
      }
    }
    else {
      // scrolling up
      if (window.scrollY < 200) {
        headerLogoCont.classList.remove('header-logo-cont-small');
      }
    }
    lastScroll = window.scrollY;
  });

  /*
* make images sticky if on top of viewport as long as container is in viewport
*/
  function setFixedImage() {
    var blockImages = document.querySelectorAll('.wp-block-image, .wp-block-post-featured-image');
    for (var i = 0; i < blockImages.length; i++) {
      var elementTop = blockImages[i].getBoundingClientRect().top,
        WrapContainerHeight = blockImages[i].parentNode.parentElement.clientHeight;

      if (elementTop <= 0) {
        if (window.matchMedia("(min-width: 576px)").matches) {
          blockImages[i].classList.add('isFixedImage');
        }

      }
      else {
        blockImages[i].classList.remove('isFixedImage');
      }
      if (elementTop < -WrapContainerHeight) {

        blockImages[i].classList.remove('isFixedImage');
      }
    }
  }
  window.addEventListener('scroll', setFixedImage);

  /*
  * Set visibility to hidden for page header on subpages after content has been scrolled
*/
  function togglePageHeaderFixedBg() {

    var whiteBg = document.querySelector('.white-bg'),
      pageHeader = document.querySelector('.page-header'),
      pageHeaderPos = pageHeader.getBoundingClientRect().top;
    if (whiteBg) {
      var whiteBgPos = whiteBg.getBoundingClientRect().top;
      if (whiteBgPos <= pageHeaderPos) {
        pageHeader.style.visibility = "hidden";
      }
      else {
        pageHeader.style.visibility = "visible";
      }
    }
  }
  window.addEventListener('scroll', togglePageHeaderFixedBg);




  /*
* Set small logo to position fixed if on same position as text logo
*/
  function setSmallLogoFixed() {

    var smallLogoLeftBorder = document.querySelectorAll('.small-logo-left-border'),
      smallLogoLeftBorderPos = 0;


    if (smallLogoLeftBorder) {


      for (var i = 0; i < smallLogoLeftBorder.length; i++) {

        if (smallLogoLeftBorder.length > 1) {

          if (window.matchMedia("(min-width: 992px)").matches) {
            smallLogoLeftBorderPos = smallLogoLeftBorder[0];
          }
          else {
            smallLogoLeftBorderPos = smallLogoLeftBorder[1];
          }
        }
        else {
          smallLogoLeftBorderPos = smallLogoLeftBorder[i];
        }

        // console.log(onScreen(smallLogoLeftBorderPos)); // tests if the element with the id of 'foo' is on screen


        // console.log(headerBrandLinkOffset.top - smallLogoLeftBorderPos);

        if (onScreen(smallLogoLeftBorderPos)) {
          smallLogoLeftBorder[i].classList.remove('smallLogoFixed');

        }
        else {
          smallLogoLeftBorder[i].classList.add('smallLogoFixed');
        }
      }
    }
  }
  window.addEventListener('scroll', setSmallLogoFixed);





  function onScreen(elem, allowElemBehind = false) {
    const scrollDist = document.documentElement.scrollTop;
    var elemOffset = window.scrollY + elem.getBoundingClientRect().top - 80,
      isHomePage = document.querySelector('.home'),
      isBlogPage = document.querySelector('.blog');
    if (window.matchMedia("(max-width: 992px)").matches) {
      elemOffset = window.scrollY + elem.getBoundingClientRect().top - 25;
    }

    if (window.matchMedia("(min-width:992px) and (max-width: 1200px)").matches) {
      elemOffset = window.scrollY + elem.getBoundingClientRect().top - 110;
    }

    if (isHomePage) {
      elemOffset = window.scrollY + elem.getBoundingClientRect().top - elem.offsetHeight - 320;
      if (window.matchMedia("(max-width: 1200px)").matches) {
        elemOffset = window.scrollY + elem.getBoundingClientRect().top - elem.offsetHeight - 230;
      }
      if (window.matchMedia("(max-width: 992px)").matches) {
        elemOffset = window.scrollY + elem.getBoundingClientRect().bottom - elem.offsetHeight - 30;
      }

    }

    if (isBlogPage) {
      elemOffset = window.scrollY + elem.getBoundingClientRect().top - elem.offsetHeight + 80;
      if (window.matchMedia("(max-width: 1200px)").matches) {
        elemOffset = window.scrollY + elem.getBoundingClientRect().top - elem.offsetHeight;
      }
      if (window.matchMedia("(max-width: 992px)").matches) {
        elemOffset = window.scrollY + elem.getBoundingClientRect().bottom - elem.offsetHeight - 30;
      }

    }



    if (!allowElemBehind && !(elemOffset + elem.offsetHeight > scrollDist))
      return false;



    return true;
  }






};



import.meta.webpackHot?.accept(animations);
